import React from 'react';
function Minis() {
    return (
      <div className="App">
          Mini
      </div>
    );
  }
  
  export default Minis;